<template>
  <div style="padding:10px">
    <van-cell style="border:1px solid #ccc" icon="filter-o" right-icon=""	@click-right-icon="filtrele" @click="t1=true" center clearable  :title="filtre.t1+' # '+filtre.t2"/>
    <van-calendar type="range" v-model="t1" @confirm="onConfirm" :min-date="minDate" />

    <div v-for="(post,index) in nakli" :key="index">
      <van-cell center  :value="'Borç : '+post.borc+''+ hesap.pb+ ' Alacak : '+post.alacak+''+ hesap.pb" :label="post.tarih">
      <template #title>
          <span class="custom-title">{{post.hc}}</span>
          <van-tag type="primary">{{post.ht}}</van-tag>
        </template>
    </van-cell>
    <van-divider style="margin:0">Bakiye : {{ post.bakiye }}</van-divider>
  </div>

  
  <div v-for="(post,index) in posts" :key="index" @click="detay(post.tur, post.seri, post.sira, post.tarih)">
      <van-cell center  :value="post[$helper.sefLink(post.ht)]+''+ hesap.pb" :label="post.tarih+' Vade:'+post.vade">
      <template #title>
          <span class="custom-title">{{post.hc}}</span>
          <van-tag type="danger">{{post.ht}}</van-tag>
        </template>
    </van-cell>
    <van-divider style="margin:0;">Bakiye : {{ post.bakiye }}</van-divider>
  </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      //cariKod : this.$helper.kodlama.decode(this.$route.params.kod)
      source: this.$store.getters.getCari.aktif,
      hesap : this.$store.getters.getHesap,
      filtre: {
        t1: this.$helper.setFiltre().yillik.t1,
        t2: this.$helper.setFiltre().yillik.t2,        
        // t1: new Date().getFullYear() + ".01.01",
        // t2: this.$helper.trtgosternoktali(new Date()),
        ckod: this.$store.getters.getCari.aktif.kod,
      },
      open: true,
      nakli: [],
      vergi: 0,
      iskonto: 0,
      ebakiye: 0,
      arr: [],
      posts: [],
      error: [],
      kalem: {
        kalem: [],
        toplam: {
          aratoplam: 0,
          iskonto1: 0,
          iskonto2: 0,
          geneltoplam: 0,
          vergi: 0,
        },
        genel: {
          evrak: "",
          tarih: "",
          evrak2: "",
        },
      },
      t1:false,
        minDate: new Date(2023, 10, 1),  //10 ekim ayı değil +1 mantığı ile aralık
        maxDate: new Date(2023, 10, 2),      
    };
  },
  created (){
    this.filtrele();
  },
  methods: {
    baslat(){
        this.t1=false;
        this.filtrele();
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
      },
      onConfirm(date) {
        this.t1 = false;
        const [start, end] = date;
        this.filtre.t2 = `${this.formatDate(end)}`
        this.filtre.t1 = `${this.formatDate(start)}`
        this.filtrele()
      },
    filtrele (){
      this.$store.commit("setLoading",[true,'Bekleyiniz']);
      this.$request.post(this.hesap.program + "/foy/", this.filtre,this.hesap).then(res => {
        if (res.status != 300) {
          this.$store.commit("setLoading",[false,'...']);
          this.posts = res.posts;
          this.nakli = res.nakli;
        }
        else {
          this.$router.push("/oturum")
        }

        //resolve(res)
      }).catch(err=>{
        this.$store.commit("setLoading",[false,'...']);
        this.$notify({ type: 'danger', message: err.message });
      })
    },
    detay(tur, seri, sira, tarih) {
      if (tur === 63 ||tur === 0) {
        this.$store.commit("setLoading",[true,'Bekleyiniz']);
      this.$request.post(this.hesap.program + "/foydetay/", {
          tur: tur,
          seri: seri,
          sira: sira,
        },this.hesap).then((res) => {
          this.kalem.kalem = [];
          this.kalem.toplam.aratoplam = 0;
          this.kalem.toplam.iskonto1 = 0;
          this.kalem.toplam.iskonto2 = 0;
          this.kalem.toplam.vergi = 0;
          this.kalem.toplam.geneltoplam = 0;
          res.forEach((ele) => {
            this.kalem.kalem.push({
              kod: ele.sth_stok_kod,
              isim: ele.isim,
              adet: ele.sth_miktar,
              birim: ele.birim,
              birim_fiyat: ele.birim_tutar,
              isk_birim_fiyat: ele.iskontolu_birim_f,
              vergi: ele.vergi,
            });
            this.kalem.toplam.aratoplam +=ele.aratoplam,
            this.kalem.toplam.iskonto1 +=ele.iskonto1,
            this.kalem.toplam.iskonto2 += ele.iskonto2,
            this.kalem.toplam.vergi += ele.vergi,
            this.kalem.toplam.geneltoplam +=ele.iskontolu_tutar + ele.vergi,
            this.kalem.genel.evrak2 =
              ele.sth_evrakno_seri + " " + ele.sth_evrakno_sira;
          });
          this.kalem.genel.evrak = seri + " " + sira;
          this.kalem.genel.tarih = tarih;
          this.$store.commit("setLoading",[false,'...']);
          this.$store .dispatch("foydetay", this.kalem)
          this.$router.push("/ekstredetay")
        });
      }
      else {
        this.$toast("Bu işlemin detayı olamaz");
      }
    }
  },
};
</script>
<style scoped>
.van-icon-filter-o,.van-icon-calendar-o,.van-icon-search{
  color:#484848 !important;
  font-size:16px !important;
}

.van-cell__right-icon{
  font-size:18px !important; color:#aca8a8 !important
}
</style>



// WEBPACK FOOTER //
// src/views/hareket.vue